import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'// 引入中文文件
// 配置中文
Validator.addLocale(zh)
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fieldBags',  // 报冲突时 可自定义修改字段名称
  delay: 0, // 错误提示的延迟时间
  strict: true, // 没有设置规则的表单不进行校验，
  enableAutoClasses: false,
  locale: 'zh_CN', // 对语言（中文）的配置
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input', //* *input|blur** 在用户输入和表单失去焦点时都进行校验 可单独写  blur或input
  inject: true
}
Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
  zh_CN: {
    messages: {
      email: () => '请输入正确的邮箱格式',
      required: (field) => field + '不能为空'
    },
    attributes: {
      email: '邮箱',
      phone: '手机',
      name: '姓名',
      sex: '性别',
      channelTitle: '具体渠道',
      trainOrgan: '毕业院校',
      schoolMajorName: '所学专业',
      address: '意向工作地点',
      post: '应聘岗位',
      channelName: '获取渠道',
      education: '学历',
      graduationYear: '毕业年份'
    }
  }
}

Validator.updateDictionary(dictionary)

Validator.extend('phone', {
  messages: {
    zh_CN: field => '请输入正确的' + field
  },
  validate: value => {
    return value.length === 11 && /^((12|13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(value)
  }
})
Validator.extend('name', {
  messages: {
    zh_CN: field => field + '必须是中文(大于1个字)',
  },
  validate: value => {
    var re = /^[\u4e00-\u9fa5]+$/;
    return value.length > 1 && re.test(value)
  }
});
Validator.extend('channelTitle', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('sex', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('trainOrgan', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('schoolMajorName', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('address', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('post', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('channelName', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('education', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
});
Validator.extend('graduationYear', {
  messages: {
    zh_CN: field => field + '不能为空',
  },
  validate: value => {

    return !!value
  }
}); 
